import React from "react";
import { FaClipboardCheck, FaHardHat, FaRegHandshake } from "react-icons/fa";
import classes from "../../../pages/Home/Home.module.scss";

const items = [
  {
    icon: <FaClipboardCheck />,
    title: "Accurate Diagnosis",
    text: "We identify the real cause of building issues before recommending practical, long-term solutions.",
  },
  {
    icon: <FaHardHat />,
    title: "Remedial Expertise",
    text: "Experienced across strata, remedial and restoration projects throughout Sydney and NSW.",
  },
  {
    icon: <FaRegHandshake />,
    title: "Honest Advice",
    text: "Clear communication, economical options and work completed to Australian Standards and the Building Code of Australia.",
  },
];

const GridBox = () => {
  return (
    <div className={classes["grid-box"]}>
      {items.map((item) => (
        <article className={classes["grid-card"]} key={item.title}>
          <div className={classes["grid-icon"]}>{item.icon}</div>
          <h3>{item.title}</h3>
          <p>{item.text}</p>
        </article>
      ))}
    </div>
  );
};

export default GridBox;
